import { DenyCircle } from '@squareup/dex-icons/market/alert';
import { Box, Paragraph20 } from '@squareup/dex-ui-shared-base';
import { commonIconStyles } from '@squareup/dex-ui-shared-icon-styles';
import clsx from 'clsx';
import React, { FC } from 'react';

import { CloseButton } from './ApiExplorerCloseButton';
import styles from './api-explorer-field-helpers.module.css';

const strings = {
  label: 'Filled as null',
  closeLabel: 'Remove null value',
};

interface Props {
  onRemove: () => void;
}

const ApiExplorerFieldNullState: FC<Props> = ({ onRemove }) => {
  return (
    <Paragraph20
      as="i"
      className={clsx(styles['flex-container'], styles['null-text'])}
      colorVariant="20"
    >
      <DenyCircle
        className={commonIconStyles['icon-fill-current-color']}
        width={16}
        height={16}
        viewBox="0 0 24 24"
      />
      <Box as="span" margin={{ horizontal: '0.5x' }}>
        {strings.label}
      </Box>
      <CloseButton labelName={strings.closeLabel} onClick={onRemove} />
    </Paragraph20>
  );
};

export { ApiExplorerFieldNullState };
